/**
 * The only analytics the free first aid needs calculator sends.
 *
 * Every property is a fixed value, so the visitor's answers never reach
 * PostHog: the type allows no free text, and
 * __tests__/marketing/first-aid-calculator-behaviour.test.tsx checks the payloads.
 */
export type FirstAidCalculatorEvent =
  /** The visitor answered a question for the first time on this page view. */
  | { event: "first_aid_calculator_used" }
  /** The visitor answered every question that applies and saw a result. */
  | { event: "first_aid_calculator_completed" };

interface Capture {
  capture?: (event: string, properties: Record<string, string>) => unknown;
}

export function trackFirstAidCalculator(posthog: Capture | null | undefined, analyticsEvent: FirstAidCalculatorEvent): void {
  posthog?.capture?.(analyticsEvent.event, { tool: "first_aid_needs_calculator" });
}
